var _defs, _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning_Icon",
    "data-name": "Warning Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f8f8f8;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #ff9e19;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        fill: #ff9e19;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4901",
    "data-name": "Rectangle 4901",
    className: "cls-1",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_10816",
    "data-name": "Path 10816",
    className: "cls-2",
    transform: "translate(8 7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 8 15.25 C 4.002339839935303 15.25 0.75 11.99765968322754 0.75 8 C 0.75 4.002339839935303 4.002339839935303 0.75 8 0.75 C 11.99765968322754 0.75 15.25 4.002339839935303 15.25 8 C 15.25 11.99765968322754 11.99765968322754 15.25 8 15.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M 8 1.5 C 4.415889739990234 1.5 1.5 4.415889739990234 1.5 8 C 1.5 11.58411026000977 4.415889739990234 14.5 8 14.5 C 11.58411026000977 14.5 14.5 11.58411026000977 14.5 8 C 14.5 4.415889739990234 11.58411026000977 1.5 8 1.5 M 8 0 C 12.41800022125244 0 16 3.581999778747559 16 8 C 16 12.41800022125244 12.41800022125244 16 8 16 C 3.581999778747559 16 0 12.41800022125244 0 8 C 0 3.581999778747559 3.581999778747559 0 8 0 Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1597",
    "data-name": "Rectangle 1597",
    className: "cls-3",
    width: 8,
    height: 1.5,
    transform: "translate(12.642 17.298) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconWhite);
export default __webpack_public_path__ + "static/media/warning-icon-white.35ec157c583c7cb0cc96057ec9f6cb43.svg";
export { ForwardRef as ReactComponent };